var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:_vm.modalRef,attrs:{"hide-footer":"","title":"Détails de l'événement","size":"lg"},on:{"hidden":_vm.destroyModal}},[_c('div',{staticClass:"text-center"},[_c('evenement-infos',{attrs:{"evenement":_vm.evenement,"editable":false}}),_c('b-button',{on:{"click":_vm.hideModal}},[_vm._v("Fermer")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }